import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

export interface LabeledCountItem {
  key: string | number;
  label: string;
  count: number;
  badgeClass?: string;
  secondaryBadge?: { text: string; class: string };
  routerLink?: any;
  queryParams?: any;
}

@Component({
  selector: 'app-labeled-count-list',
  standalone: true,
  imports: [RouterLink, NgClass],
  template: `
    <div class="divide-y divide-gray-50">
      @for (item of items; track item.key) {
        <a
          [routerLink]="item.routerLink ?? null"
          [queryParams]="item.queryParams"
          class="flex items-center justify-between py-1.5 transition-colors"
          [class.hover:bg-gray-50]="item.routerLink"
          [class.cursor-default]="!item.routerLink"
        >
          <span class="rounded-full px-2 py-0.5 text-[10px] font-semibold capitalize leading-none" [ngClass]="item.badgeClass ?? 'bg-gray-50 text-gray-700'">
            {{ item.label }}
          </span>
          <div class="flex items-center gap-1.5">
            @if (item.secondaryBadge) {
              <span class="rounded-full px-1.5 py-0.5 text-[10px] font-bold" [ngClass]="item.secondaryBadge.class">{{ item.secondaryBadge.text }}</span>
            }
            <span class="text-default text-xs font-bold">{{ item.count }}</span>
          </div>
        </a>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabeledCountListComponent {
  @Input() items: LabeledCountItem[] = [];
}
